import { Component, EventEmitter, Output, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { RowOptionButtons, RowOptionChoice } from '../single-field.model';

@Component({
    selector: 'r1-compass-lib-row-multiple-options',
    imports: [MatButtonModule, MatMenuModule, MatIconModule],
    template: `
        <button class="options" mat-button [matMenuTriggerFor]="optionsMenu" type="button">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #optionsMenu="matMenu">
            @for (option of rowOptions(); track $index) {
                @if (option.value !== 'delete') {
                    @if (option.show) {
                        <button
                            mat-menu-item
                            (click)="onClickOption(option)"
                            [attr.data-testid]="option.display"
                            type="button">
                            {{ option.display }}
                        </button>
                    }
                } @else if (option.value === 'delete' && rowDeletable()) {
                    <button
                        mat-menu-item
                        (click)="onClickOption(option)"
                        [attr.data-testid]="option.display"
                        type="button">
                        {{ option.display }}
                    </button>
                }
            }
        </mat-menu>
    `,
    styles: [],
})
export class RowMultipleOptionsComponent {
    rowOptions = input.required<RowOptionButtons[]>();

    index = input.required<number>();

    totalRequiredRows = input.required<number>();

    rowDeletable = computed(() => this.index() + 1 > this.totalRequiredRows());

    @Output()
    clickOption: EventEmitter<RowOptionChoice> = new EventEmitter<RowOptionChoice>();

    onClickOption(option: RowOptionButtons) {
        this.clickOption.emit({ index: this.index(), ...option });
    }
}
